<template>
    <div class="parent-pages-overview">
        <div
            class="magazine-page"
            v-for="parentPage in magazine.parent_pages"
            :class="[
                { checked: parentPage?.finished_at },
                parentPage.page.thumb === null && 'no-thumbnail btn-missing-image remove-icon-margin',
            ]"
            :key="parentPage.id">
            <img
                v-if="parentPage.page.thumb !== null"
                :src="parentPage.page.thumb" />

            <ul class="description">
                <li class="page-info">
                    <p class="label">{{ $t('magazine.name_student') }}:</p>
                    {{ parentPage.name_student }}
                </li>
                <li class="page-info">
                    <p class="label">{{ $t('magazine.name_parent') }}:</p>
                    {{ parentPage.name_parent }}
                </li>
                <li
                    class="highres-link"
                    v-if="parentPage.page.highres">
                    <a
                        :href="parentPage.page.highres"
                        target="_blank">
                        {{ $t('magazine.highres_available') }}
                    </a>
                </li>

                <li>
                    <b-button
                        class="btn-approve"
                        v-if="parentPage.page.status !== 'green'"
                        variant="primary"
                        @click="approve(parentPage)">
                        {{ $t('magazine.parent_page.get_highres') }}
                    </b-button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Design2021MagazineParentPagePageComponent from './design-2021-magazine-parent-page-page-component.vue';

export default {
    name: 'design-2021-magazine-parent-page-overview-component',
    components: { Design2021MagazineParentPagePageComponent },
    props: {
        magazineIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            magazine: this.magazineIn,
        };
    },
    methods: {
        approve(parentPage) {
            let data = {
                id: parentPage.page.id,
            };

            this.axios.post(this.routes.magazinePageApprove(), data).then(
                (response) => {
                    parentPage.page.status = 'green';
                    this.magazine.parent_pages.map((parentPage0) => {
                        if (parentPage0.id === parentPage.id) {
                            return parentPage;
                        }
                        return parentPage0;
                    });
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.parent-pages-overview {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: $grid-gutter-width;
}

.magazine-page {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: map-get($grid-gutter-spacing, 'twenty-one') $grid-gutter-width;
    flex-wrap: wrap;
    flex: 1 0 100%;
    align-self: stretch;
    padding: map-get($grid-gutter-spacing, 'twenty-one');
    background-color: $white;
    border-radius: $border-radius-content;

    img {
        height: auto;
        width: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: $border-radius-content;
        border: 1px solid $border-color;
    }

    &.checked {
        &:before {
            content: '\f00c';
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: 'Font Awesome 5 Pro';
            background-color: $success;
            color: $white;
            line-height: 1;
            font-size: $base-font-size;
            padding: map-get($grid-gutter-spacing, 'five');
            border-radius: $border-radius-sm;
            position: absolute;
            left: 36px;
            top: 36px;
        }
    }
}

.description {
    padding-left: 0;
    list-style: none;
    margin: 0;
    align-self: flex-start;
    height: 100%;

    .label {
        display: inline-block;
        width: 98px;
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}

.btn-approve {
    font-size: $default-font-size;
    line-height: 1;
    padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'ten');
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .magazine-page {
        flex: 0 0 calc(50% - map-get($grid-gutter-spacing, 'fifteen'));

        img {
            max-width: 250px;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .magazine-page {
        flex: 0 0 calc(32% - map-get($grid-gutter-spacing, 'fifteen'));
    }
}

@media (min-width: map-get($grid-breakpoints, 'xxl')) {
    .magazine-page {
        flex: 0 0 calc(33% - map-get($grid-gutter-spacing, 'fifteen'));
    }
}
</style>
